import MedicalBriefcase from "./SVG/medical-briefcase.svg?react";

const MedicalBriefcaseIcon = () => {
  return <MedicalBriefcase />;
};

export default MedicalBriefcaseIcon;
